// chatRoutePrefetch (R5-02, Diagnose B1-4 Befund 3)
//
// Hier steht die import()-Fabrik der /chat-Route — und NUR sie. `routes.tsx`
// baut `ChatPage` aus genau dieser Fabrik (sonst waere das Vorwaermen ein
// anderer Modul-Eintrag und der Chunk nach dem Klick trotzdem kalt), und die
// Entdecken-Flaechen rufen `prefetchChatRoute()` beim Mounten.
//
// Warum ein eigenes Modul und nicht direkt in `routes.tsx`: `routes.tsx` zieht
// den gesamten Routenbaum (AppShell, RequireAuth, Admin-Scope …) statisch mit.
// Eine Detailseite, die nur vorwaermen will, haette damit den halben
// Anwendungsrumpf im Import-Graphen — im Bundle wie in jedem Vitest-Lauf, der
// diese Seite rendert. Die Fabrik bleibt trotzdem EINE einzige.
//
// Hintergrund: die /chat-Route zieht gemessen 24 Chunks / 114 KB nach, weil
// pages/chat/index.tsx alle Sheets und Dialoge statisch importiert. Ohne
// Vorwaermen beginnt dieser Download erst nach dem „Spielen"-Klick.

export const chatRouteImport = () => import('../pages/chat');

/**
 * Waermt den Chunk-Graphen der /chat-Route vor. Idempotent (der Modul-Cache
 * beantwortet jeden weiteren Aufruf sofort) und still: ein fehlgeschlagener
 * Prefetch darf nie sichtbar werden — der echte Import beim Routenwechsel
 * bringt mit `lazyWithReload` seine eigene Heilung mit.
 */
export function prefetchChatRoute(): void {
  try {
    void chatRouteImport().catch(() => { /* still: reines Vorladen */ });
  } catch (e) {
    /* still: ein Prefetch darf nie eine Seite kippen */
  }
}

// W2-B (Review M3): dasselbe fuer den Charakter-Chat. Die Sofortstart-Karten
// der Begleiter-Tuer oeffnen ihn nach einem Tipp; ohne Vorwaermen blieb die
// alte Seite unter v7_startTransition stehen, bis der Chunk geladen war — und
// ein ungeduldiger zweiter Tipp legte eine zweite Figur an. `routes.tsx` baut
// `CharacterChatPage` aus GENAU dieser Fabrik.
export const characterChatRouteImport = () => import('../pages/character-chat');

/** Waermt den Chunk-Graphen der /character-chat-Route vor (still, idempotent). */
export function prefetchCharacterChatRoute(): void {
  try {
    void characterChatRouteImport().catch(() => { /* still: reines Vorladen */ });
  } catch (e) {
    /* still: ein Prefetch darf nie eine Seite kippen */
  }
}
